module.exports = __webpack_public_path__ + "static/img/user1.28d56f0.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user1.jpeg
// module id = 7nyq
// module chunks = 12